/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue/dist/vue.esm.js';
import bus from '../bus.js';
import { store } from '../store';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCheck);
Vue.component('font-awesome-icon', FontAwesomeIcon)

const __vue_script__ = {
	data () {
		return {
			strings: ui_data.strings,
			pricingData: this.$pricingData,
		}
	},
	methods: {
		openPricingColumnModal: function(contents) {
			bus.$emit( 'showPricingModal' );
			this.$store.commit( 'updatePricingModal', contents );
		},
	},
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-tables"},[_c('div',{staticClass:"pricing-tables__wrap"},[(_vm.pricingData.columnOnePrice && _vm.pricingData.columnOneName)?_c('div',{staticClass:"pricing-tables__column"},[_c('div',{staticClass:"column-contents"},[_c('p',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnOneName)}}),_vm._v(" "),_c('h3',{staticClass:"pricing-tables__column-price",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnOnePrice)}}),_vm._v(" "),_c('ul',_vm._l((_vm.pricingData.columnOne),function(item){return _c('li',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check'],"size":"1x"}}),_vm._v(" "),_c('span',{staticClass:"list-item"},[_vm._v(_vm._s(item.feature_name))])],1)}),0)]),_vm._v(" "),(_vm.pricingData.columnOneLinkType == 'url')?_c('a',{staticClass:"learn-more",attrs:{"href":_vm.pricingData.columnOneUrl}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnOneLinkType == 'popup')?_c('a',{staticClass:"learn-more",on:{"click":function($event){return _vm.openPricingColumnModal(_vm.pricingData.columnOnePopupContent)}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnTwoPrice && _vm.pricingData.columnTwoName)?_c('div',{staticClass:"pricing-tables__column"},[_c('div',{staticClass:"column-contents"},[_c('p',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnTwoName)}}),_vm._v(" "),_c('h3',{staticClass:"pricing-tables__column-price",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnTwoPrice)}}),_vm._v(" "),_c('ul',_vm._l((_vm.pricingData.columnTwo),function(item){return _c('li',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check'],"size":"1x"}}),_vm._v(" "),_c('span',{staticClass:"list-item"},[_vm._v(_vm._s(item.feature_name))])],1)}),0)]),_vm._v(" "),(_vm.pricingData.columnTwoLinkType == 'url')?_c('a',{staticClass:"learn-more",attrs:{"href":_vm.pricingData.columnTwoUrl}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnTwoLinkType == 'popup')?_c('a',{staticClass:"learn-more",on:{"click":function($event){return _vm.openPricingColumnModal(_vm.pricingData.columnTwoPopupContent)}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnThreePrice && _vm.pricingData.columnThreeName)?_c('div',{staticClass:"pricing-tables__column"},[_c('div',{staticClass:"column-contents"},[_c('p',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnThreeName)}}),_vm._v(" "),_c('h3',{staticClass:"pricing-tables__column-price",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnThreePrice)}}),_vm._v(" "),_c('ul',_vm._l((_vm.pricingData.columnThree),function(item){return _c('li',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check'],"size":"1x"}}),_vm._v(" "),_c('span',{staticClass:"list-item"},[_vm._v(_vm._s(item.feature_name))])],1)}),0)]),_vm._v(" "),(_vm.pricingData.columnThreeLinkType == 'url')?_c('a',{staticClass:"learn-more",attrs:{"href":_vm.pricingData.columnThreeUrl}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnThreeLinkType == 'popup')?_c('a',{staticClass:"learn-more",on:{"click":function($event){return _vm.openPricingColumnModal(_vm.pricingData.columnThreePopupContent)}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnFourPrice && _vm.pricingData.columnFourName)?_c('div',{staticClass:"pricing-tables__column"},[_c('div',{staticClass:"column-contents"},[_c('p',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnFourName)}}),_vm._v(" "),_c('h3',{staticClass:"pricing-tables__column-price",domProps:{"innerHTML":_vm._s(_vm.pricingData.columnFourPrice)}}),_vm._v(" "),_c('ul',_vm._l((_vm.pricingData.columnFour),function(item){return _c('li',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check'],"size":"1x"}}),_vm._v(" "),_c('span',{staticClass:"list-item"},[_vm._v(_vm._s(item.feature_name))])],1)}),0)]),_vm._v(" "),(_vm.pricingData.columnFourLinkType == 'url')?_c('a',{staticClass:"learn-more",attrs:{"href":_vm.pricingData.columnFourUrl}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.pricingData.columnFourLinkType == 'popup')?_c('a',{staticClass:"learn-more",on:{"click":function($event){return _vm.openPricingColumnModal(_vm.pricingData.columnFourPopupContent)}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.strings['Learn More'])+"\n\t\t\t")]):_vm._e()]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PricingTables.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__